var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "properties-field",
      class: { "properties-field-group": _vm.isGroup },
      attrs: { id: _vm.id[_vm.stackLevel - 1] }
    },
    [
      _vm.fieldDetail
        ? _c("div", { staticClass: "wrap-properties" }, [
            _c("div", { staticClass: "properties-field-title" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "close-properties",
                  on: {
                    click: function($event) {
                      !_vm.showModalFieldLibrary ? _vm.submitForm(true) : null
                    }
                  }
                },
                [_vm._v("\n        ×\n      ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "wrap-type" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/new-form-ui/field-icon/" +
                      _vm.fieldDetail.type +
                      ".svg")
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-type" }, [
                  _vm._v(_vm._s(_vm.propertyTitle))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "properties-field-content" }, [
              _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  !_vm.isSearch
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form",
                                {
                                  class: {
                                    "error-input": _vm.$v.dataSetup.key.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Key ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: { placeholder: "Field key" },
                                    model: {
                                      value: _vm.dataSetup.key,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dataSetup, "key", $$v)
                                      },
                                      expression: "dataSetup.key"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "field-information" },
                                    [
                                      _vm._v(
                                        "\n                A distinct characteristic of an object specified\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isDataset &&
                          _vm.type !== "data_preview" &&
                          _vm.dataSetup.type.id !== "separator" &&
                            _vm.dataSetup.type.id !== "custom_html" &&
                            _vm.dataSetup.type.id !== "text_label" &&
                            _vm.dataSetup.type.id !== "progress_bar" &&
                            _vm.dataSetup.type.id !== "group" &&
                            _vm.dataSetup.type.id !== "table_group"
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "d-flex flex-column my-2",
                                  attrs: { cols: "4" }
                                },
                                [
                                  _c("label", [_vm._v(" Mandatory ")]),
                                  _vm._v(" "),
                                  _c("j-switch", {
                                    model: {
                                      value: _vm.dataSetup.isMandatory,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "isMandatory",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.isMandatory"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isDataset &&
                          !_vm.isTableEditable &&
                          _vm.type !== "data_preview" &&
                          _vm.dataSetup.type.id !== "separator" &&
                            _vm.dataSetup.type.id !== "custom_html" &&
                            _vm.dataSetup.type.id !== "text_label" &&
                            _vm.dataSetup.type.id !== "progress_bar" &&
                            _vm.dataSetup.type.id !== "group" &&
                            _vm.dataSetup.type.id !== "table_group"
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "d-flex flex-column my-2",
                                  attrs: { cols: "4" }
                                },
                                [
                                  _c("label", [_vm._v(" Disable ")]),
                                  _vm._v(" "),
                                  _c("j-switch", {
                                    model: {
                                      value: _vm.dataSetup.isDisable,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "isDisable",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.isDisable"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isDataset &&
                          !_vm.isTableEditable &&
                          _vm.type !== "data_preview" &&
                          _vm.dataSetup.type.id !== "separator" &&
                            _vm.dataSetup.type.id !== "custom_html" &&
                            _vm.dataSetup.type.id !== "text_label" &&
                            _vm.dataSetup.type.id !== "progress_bar"
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "d-flex flex-column my-2",
                                  attrs: { cols: "4" }
                                },
                                [
                                  _c("label", [_vm._v(" Hidden ")]),
                                  _vm._v(" "),
                                  _c("j-switch", {
                                    model: {
                                      value: _vm.dataSetup.isHidden,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dataSetup, "isHidden", $$v)
                                      },
                                      expression: "dataSetup.isHidden"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isTableEditable
                    ? _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.name.$error }
                        },
                        [
                          _c("label", [_vm._v(" Label ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Enter field label" },
                            model: {
                              value: _vm.dataSetup.name,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "name", $$v)
                              },
                              expression: "dataSetup.name"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            Field Labels are the name of the data entry area form that help let users know what information to enter into the field.\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUsePlaceholder
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.placeholder.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Placeholder ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Enter field placeholder" },
                            model: {
                              value: _vm.dataSetup.placeholder,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "placeholder", $$v)
                              },
                              expression: "dataSetup.placeholder"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            Placeholders are words that can refer to an instance of value\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "group" && _vm.parentType === "table_group"
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.width.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Width ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.widthOptions,
                              placeholder: "Select Width",
                              label: "name"
                            },
                            model: {
                              value: _vm.dataSetup.width,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "width", $$v)
                              },
                              expression: "dataSetup.width"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isUseGrid
                    ? _c(
                        "b-form",
                        {
                          class: { "error-input": _vm.$v.dataSetup.grid.$error }
                        },
                        [
                          _c("label", [_vm._v(" Width ")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-width" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dataSetup.grid,
                                  expression: "dataSetup.grid"
                                }
                              ],
                              attrs: { type: "range", min: "1", max: "12" },
                              domProps: { value: _vm.dataSetup.grid },
                              on: {
                                __r: function($event) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "grid",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _c("span", [_vm._v(_vm._s(_vm.dataSetup.grid))]),
                              _vm._v(" / 12\n            ")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            The width-size property defines the number of columns in your width layout, and it can define the width of each column.\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataSetup.type.id === "text_label"
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input":
                              _vm.$v.dataSetup.formatTextLabel.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Format ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              custom: true,
                              options: _vm.formatOptions,
                              placeholder: "Select format"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "node-custom",
                                fn: function(node) {
                                  return [
                                    _c("img", {
                                      staticStyle: {
                                        width: "14px",
                                        height: "auto",
                                        "margin-right": "5px"
                                      },
                                      attrs: {
                                        src: require("@/assets/icon/column-type/" +
                                          _vm.setIconType(node.node.id) +
                                          ".svg")
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(node.node.label) +
                                        "\n            "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.dataSetup.formatTextLabel,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "formatTextLabel", $$v)
                              },
                              expression: "dataSetup.formatTextLabel"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            The format is the format for showing label text\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.dataSetup.type.id === "date" ||
                    _vm.dataSetup.type.id === "time" ||
                    _vm.dataSetup.type.id === "date_time" ||
                    _vm.dataSetup.type.id === "timer" ||
                    (_vm.dataSetup.type.id === "text_label" &&
                      (_vm.dataSetup.formatTextLabel === "datetime" ||
                        _vm.dataSetup.formatTextLabel === "time" ||
                        _vm.dataSetup.formatTextLabel === "dd-mmm-yyyy" ||
                        _vm.dataSetup.formatTextLabel === "mmmm dd, yyyy"))) &&
                  !_vm.isSearch &&
                  !_vm.isDataset
                    ? _c(
                        "b-form",
                        [
                          _c("label", [_vm._v(" Timezone ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.listTimezone,
                              placeholder: "Select Timezone",
                              label: "text",
                              "value-format": "object"
                            },
                            model: {
                              value: _vm.dataSetup.timezone,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "timezone", $$v)
                              },
                              expression: "dataSetup.timezone"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSearch &&
                  !_vm.isDataset &&
                  !_vm.isTableEditable &&
                  (_vm.dataSetup.type.id === "currency" ||
                    _vm.dataSetup.type.id === "currency_selection" ||
                    (_vm.dataSetup.type.id === "text_label" &&
                      _vm.dataSetup.formatTextLabel === "currency"))
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input":
                              _vm.$v.dataSetup.defaultCurrency.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Default Currency ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_currency,
                              label: "symbol_name",
                              placeholder: "Select Default Currency"
                            },
                            on: { getData: _vm.changeCurrency },
                            model: {
                              value: _vm.$v.dataSetup.defaultCurrency.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.dataSetup.defaultCurrency,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.dataSetup.defaultCurrency.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            The default currency is the value currency specified in the field value attribute\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSearch &&
                  !_vm.isDataset &&
                  !_vm.isTableEditable &&
                  _vm.type === "default" &&
                  (_vm.dataSetup.type.id === "text" ||
                    _vm.dataSetup.type.id === "descriptive" ||
                    _vm.dataSetup.type.id === "number" ||
                    _vm.dataSetup.type.id === "number_decimal" ||
                    _vm.dataSetup.type.id === "date" ||
                    _vm.dataSetup.type.id === "time" ||
                    _vm.dataSetup.type.id === "date_time" ||
                    _vm.dataSetup.type.id === "currency" ||
                    _vm.dataSetup.type.id === "currency_selection" ||
                    _vm.dataSetup.type.id === "single_selection" ||
                    _vm.dataSetup.type.id === "slider" ||
                    (_vm.dataSetup.type.id === "text_label" &&
                      _vm.dataSetup.formatTextLabel))
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.defaultValue.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Default Value ")]),
                          _vm._v(" "),
                          _vm.dataSetup.type.id === "text" ||
                          _vm.dataSetup.type.id === "descriptive" ||
                          _vm.dataSetup.type.id === "single_selection" ||
                          _vm.dataSetup.type.id === "slider" ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "text")
                            ? _c("j-input", {
                                attrs: { placeholder: "Enter Default Value" },
                                model: {
                                  value: _vm.dataSetup.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                                  },
                                  expression: "dataSetup.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataSetup.type.id === "number" ||
                          _vm.dataSetup.type.id === "number_decimal" ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "number")
                            ? _c("j-input", {
                                attrs: {
                                  placeholder: "Enter Default Value",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.dataSetup.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                                  },
                                  expression: "dataSetup.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataSetup.type.id === "date" ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "dd-mmm-yyyy") ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "mmmm dd, yyyy")
                            ? _c("j-date-time", {
                                staticClass: "m__b--25",
                                attrs: {
                                  data: _vm.dataSetup.defaultValue,
                                  placeholder: "Enter Default Value",
                                  format: "MMM dd, yyyy"
                                },
                                on: {
                                  getTimestamp: function($event) {
                                    _vm.setValueDateAndAtime(
                                      $event,
                                      _vm.dataSetup.defaultValue
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataSetup.type.id === "time" ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "time")
                            ? _c("j-clockpicker", {
                                attrs: {
                                  data: _vm.dataSetup.defaultValue,
                                  placeholder: "Enter Default Value"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.setValueDateAndAtime(
                                      $event,
                                      _vm.dataSetup.defaultValue
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataSetup.type.id === "date_time" ||
                          (_vm.dataSetup.type.id === "text_label" &&
                            _vm.dataSetup.formatTextLabel === "datetime")
                            ? _c("j-date-time", {
                                staticClass: "m__b--25",
                                attrs: {
                                  type: "datetime",
                                  data: _vm.dataSetup.defaultValue,
                                  placeholder: "Enter Default Value",
                                  format: "MMM dd, yyyy, HH:mm"
                                },
                                on: {
                                  getTimestamp: function($event) {
                                    _vm.setValueDateAndAtime(
                                      $event,
                                      _vm.dataSetup.defaultValue
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.dataSetup.type.id === "currency" ||
                            _vm.dataSetup.type.id === "currency_selection" ||
                            (_vm.dataSetup.type.id === "text_label" &&
                              _vm.dataSetup.formatTextLabel === "currency")) &&
                          _vm.showDefaultCurrency
                            ? _c("j-currency", {
                                attrs: {
                                  options: _vm.setCurrencyOptions(
                                    _vm.dataSetup.isAllowMinusValue
                                  ),
                                  input_mode: true,
                                  placeholder: "Enter Default Value"
                                },
                                model: {
                                  value: _vm.dataSetup.defaultValue,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "defaultValue", $$v)
                                  },
                                  expression: "dataSetup.defaultValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            The default value is the value specified in the field value attribute\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSearch &&
                  !_vm.isDataset &&
                  !_vm.isTableEditable &&
                  _vm.dataSetup.type.id === "currency_selection"
                    ? _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.loadRate.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Function Load Rate ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.listFunction,
                              placeholder: "Select Function",
                              label: "name"
                            },
                            model: {
                              value: _vm.$v.dataSetup.loadRate.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.dataSetup.loadRate,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.dataSetup.loadRate.$model"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-information" }, [
                            _vm._v(
                              "\n            The function load rate is the function for get rate currency\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataSetup.type.id === "dynamic_field"
                    ? _c("div", { staticClass: "configuration-section" }, [
                        _c(
                          "h4",
                          { staticClass: "configuration-section-title" },
                          [_vm._v("View Options")]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "configuration-section-desc" }, [
                          _vm._v(
                            "\n            Options for field implementation as settings view or render view\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          _vm._l(_vm.viewDynamicOptions, function(view) {
                            return _c(
                              "div",
                              {
                                key: view.id,
                                staticClass: "div-list-language",
                                class: {
                                  active: view.id === _vm.dataSetup.viewOptions,
                                  disabled:
                                    (!_vm.isDetailView &&
                                      view.id === "settings") ||
                                    (_vm.isDetailView &&
                                      !_vm.isPageScreen &&
                                      view.id === "settings")
                                },
                                on: {
                                  click: function($event) {
                                    _vm.changeViewDynamic(view.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(view.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataSetup.type.id === "slider"
                    ? _c("div", { staticClass: "configuration-section" }, [
                        _c(
                          "h4",
                          { staticClass: "configuration-section-title" },
                          [_vm._v("Slider Options")]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "configuration-section-desc" }, [
                          _vm._v(
                            "\n            Options for field implementation as Slider Range (Number) or Selection (Text)\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "div-summary-list-type mt-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "type",
                                class: {
                                  "type--active":
                                    _vm.dataSetup.sliderOptions === "range"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.dataSetup.sliderOptions = "range"
                                  }
                                }
                              },
                              [_vm._v("\n              RANGE\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "type",
                                class: {
                                  "type--active":
                                    _vm.dataSetup.sliderOptions === "string"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.dataSetup.sliderOptions = "string"
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              SELECTION\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.dataSetup.type.id !== "separator" &&
              _vm.dataSetup.type.id !== "custom_html" &&
              !_vm.isTableEditable
                ? _c(
                    "div",
                    { staticClass: "section-field input-field" },
                    [
                      _c("h4", { staticClass: "title-section" }, [
                        _vm._v("Parse Value To")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          class: {
                            "error-input": _vm.$v.dataSetup.variable.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Column ")]),
                          _vm._v(" "),
                          _vm.parentType.includes("external_api")
                            ? _c("j-input", {
                                attrs: { placeholder: "Enter Column" },
                                model: {
                                  value: _vm.dataSetup.variable,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "variable", $$v)
                                  },
                                  expression: "dataSetup.variable"
                                }
                              })
                            : _c("j-single-select", {
                                attrs: {
                                  options: _vm.variableOptionsFiltered,
                                  placeholder: "Select Column",
                                  "value-format": "object",
                                  label: "label"
                                },
                                model: {
                                  value: _vm.dataSetup.variable,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "variable", $$v)
                                  },
                                  expression: "dataSetup.variable"
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isHaveConfig
                ? _c("div", { staticClass: "section-field input-field" }, [
                    _c("h4", { staticClass: "title-section" }, [
                      _vm._v("Configuration")
                    ]),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "location"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.isShowMaps.$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "configuration-toggle-in-title"
                                  },
                                  [
                                    _c("div", { staticClass: "wrap-title" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "configuration-section-title"
                                        },
                                        [_vm._v("Show Maps")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "configuration-section-desc m-0"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Displays a map according to the specified location\n                "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.dataSetup.isShowMaps,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isShowMaps",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.isShowMaps"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "location"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Location Type")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            The type of location that will be used as an option when the user opens the form\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.locationType.$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [_vm._v("Current Location")]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.currentLocation,
                                        callback: function($$v) {
                                          _vm.currentLocation = $$v
                                        },
                                        expression: "currentLocation"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [_vm._v("Manual Location")]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.manualLocation,
                                        callback: function($$v) {
                                          _vm.manualLocation = $$v
                                        },
                                        expression: "manualLocation"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "single_selection" ||
                    _vm.dataSetup.type.id === "multiple_selection" ||
                    _vm.dataSetup.type.id === "photo" ||
                    _vm.dataSetup.type.id === "attachment" ||
                    (_vm.dataSetup.type.id === "slider" &&
                      _vm.dataSetup.sliderOptions === "string")
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.dataSetup.type.id === "attachment"
                                        ? "Attachment Items"
                                        : "Options List"
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.dataSetup.type.id === "attachment"
                                        ? "Attachment list, user can attach one or all attachments."
                                        : "Option list is displays a list of values, user can be select one from the list."
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.options, function(
                              itemOptions,
                              index
                            ) {
                              return _c("div", { key: index }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "div-input-option",
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.options.$each[index]
                                          .$error
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.dataSetup.options[index],
                                          expression: "dataSetup.options[index]"
                                        }
                                      ],
                                      attrs: {
                                        placeholder:
                                          _vm.dataSetup.type.id === "attachment"
                                            ? "Item"
                                            : "Option",
                                        type: "text"
                                      },
                                      domProps: {
                                        value: _vm.dataSetup.options[index]
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.dataSetup.options,
                                            index,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteOptions(index)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addoptions }
                              },
                              [
                                _vm._v(
                                  "\n            + Add " +
                                    _vm._s(
                                      _vm.dataSetup.type.id === "attachment"
                                        ? "item"
                                        : "options"
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "slider" &&
                    _vm.dataSetup.sliderOptions === "range"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("\n            Range Option\n          ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Options are displayed as a range from minimum to maximum value\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form",
                                      [
                                        _c("label", [_vm._v("Minimum")]),
                                        _vm._v(" "),
                                        _c("j-input", {
                                          attrs: {
                                            type: "number",
                                            placeholder: "Enter minimum value"
                                          },
                                          model: {
                                            value: _vm.dataSetup.sliderMinimum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "sliderMinimum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dataSetup.sliderMinimum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { md: "6" } },
                                  [
                                    _c(
                                      "b-form",
                                      [
                                        _c("label", [_vm._v("Maximum")]),
                                        _vm._v(" "),
                                        _c("j-input", {
                                          attrs: {
                                            type: "number",
                                            placeholder: "Enter maximum value"
                                          },
                                          model: {
                                            value: _vm.dataSetup.sliderMaximum,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "sliderMaximum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dataSetup.sliderMaximum"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "radio" ||
                    _vm.dataSetup.type.id === "checkbox"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Options List")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Option list is displays a list of values, user can be select one from the list.\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.optionsObject, function(
                              itemOptions,
                              index
                            ) {
                              return _c("div", { key: index }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "div-input-option",
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.optionsObject.$each[
                                          index
                                        ].label.$error ||
                                        _vm.$v.dataSetup.optionsObject.$each[
                                          index
                                        ].value.$error
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.dataSetup.optionsObject[index]
                                              .label,
                                          expression:
                                            "dataSetup.optionsObject[index].label"
                                        }
                                      ],
                                      staticStyle: { width: "40%" },
                                      attrs: {
                                        type: "text",
                                        placeholder: "Label"
                                      },
                                      domProps: {
                                        value:
                                          _vm.dataSetup.optionsObject[index]
                                            .label
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.dataSetup.optionsObject[index],
                                            "label",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.dataSetup.optionsObject[index]
                                              .value,
                                          expression:
                                            "dataSetup.optionsObject[index].value"
                                        }
                                      ],
                                      staticStyle: { width: "40%" },
                                      attrs: {
                                        type: "text",
                                        placeholder: "Value"
                                      },
                                      domProps: {
                                        value:
                                          _vm.dataSetup.optionsObject[index]
                                            .value
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.dataSetup.optionsObject[index],
                                            "value",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteOptionsObject(index)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addoptionsObject }
                              },
                              [
                                _vm._v(
                                  "\n            + Add options\n          "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "attachment" ||
                    _vm.dataSetup.type.id === "multiple_attachment_dynamic" ||
                    _vm.dataSetup.type.id === "single_attachment"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Accepted File Type")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            File types allowed to upload\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.acceptedFileType.$error
                                }
                              },
                              [
                                _c("label", [_vm._v("File Type")]),
                                _vm._v(" "),
                                _c("j-multi-select", {
                                  attrs: {
                                    options: _vm.list_accepted_file_type,
                                    placeholder: "Select File Type"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.acceptedFileType.$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.acceptedFileType,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.acceptedFileType.$model"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "attachment" ||
                    _vm.dataSetup.type.id === "multiple_attachment_dynamic" ||
                    _vm.dataSetup.type.id === "single_attachment"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Attachment Source")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Choose the method to be the source of the attachment\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.isUseCamera.$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [_vm._v("File Manager")]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.dataSetup.sourceCamera,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "sourceCamera",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.sourceCamera"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [_vm._v("Rear Camera")]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.rearCamera,
                                        callback: function($$v) {
                                          _vm.rearCamera = $$v
                                        },
                                        expression: "rearCamera"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-input-location" },
                                  [
                                    _c("label", [_vm._v("Front Camera")]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.frontCamera,
                                        callback: function($$v) {
                                          _vm.frontCamera = $$v
                                        },
                                        expression: "frontCamera"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "attachment" ||
                    _vm.dataSetup.type.id === "multiple_attachment_dynamic" ||
                    _vm.dataSetup.type.id === "single_attachment"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "h4",
                            { staticClass: "configuration-section-title" },
                            [_vm._v("View Style Options")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "configuration-section-desc" },
                            [
                              _vm._v(
                                "\n            Options for style field for attachment\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "div-summary-list-type mt-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "type",
                                  class: {
                                    "type--active":
                                      _vm.dataSetup.viewStyleAttachment ===
                                      "list"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dataSetup.viewStyleAttachment = "list"
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/style-attachment-list" +
                                        (_vm.dataSetup.viewStyleAttachment ===
                                        "list"
                                          ? "-active"
                                          : "") +
                                        ".svg"),
                                      height: "10"
                                    }
                                  }),
                                  _vm._v("\n              List\n            ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "type",
                                  class: {
                                    "type--active":
                                      _vm.dataSetup.viewStyleAttachment ===
                                      "grid"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dataSetup.viewStyleAttachment = "grid"
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/icon/style-attachment-grid" +
                                        (_vm.dataSetup.viewStyleAttachment ===
                                        "grid"
                                          ? "-active"
                                          : "") +
                                        ".svg"),
                                      height: "10"
                                    }
                                  }),
                                  _vm._v("\n              Grid\n            ")
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "dynamic_field" &&
                    _vm.dataSetup.viewOptions === "render"
                      ? _c(
                          "div",
                          {
                            staticClass: "configuration-section",
                            class: {
                              "error-input":
                                _vm.dataSetup.type.id === "dynamic_field" &&
                                _vm.dataSetup.viewOptions === "render" &&
                                _vm.$v.dataSetup.sourceData.fieldReference
                                  .$error
                            }
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Field Reference")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            The field will be related to the reference field\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.fieldReference
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Field ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field_reference,
                                    label: "label",
                                    placeholder: "Select field"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.fieldReference
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData
                                          .fieldReference,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.fieldReference.$model"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record" ||
                    _vm.dataSetup.type.id === "multiple_relation_record" ||
                    (_vm.dataSetup.type.id === "dynamic_field" &&
                      _vm.dataSetup.viewOptions === "render")
                      ? _c(
                          "div",
                          {
                            staticClass: "configuration-section",
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.sourceData.tableGroup.$error
                            }
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Data Source")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Choose the data table that will be used as the data source\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.tableGroup
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Table Group ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    "error-required":
                                      _vm.$v.dataSetup.sourceData.tableGroup
                                        .$error,
                                    options: _vm.tableGroupOptions,
                                    placeholder: "Select Table Group",
                                    "value-format": "object",
                                    label: "name"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.tableGroup
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData.tableGroup,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.tableGroup.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.form.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Table ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    "error-required":
                                      _vm.$v.dataSetup.sourceData.form.$error,
                                    disabled: !_vm.dataSetup.sourceData
                                      .tableGroup,
                                    options: _vm.tableOptions,
                                    placeholder: "Select Table",
                                    "value-format": "object",
                                    label: "name"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.form.$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData.form,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.form.$model"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record_external_api" ||
                    _vm.dataSetup.type.id ===
                      "multiple_relation_record_external_api"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "h4",
                            { staticClass: "configuration-section-title" },
                            [_vm._v("Data Source")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "configuration-section-desc" },
                            [
                              _vm._v(
                                "\n            Fetching data sources using API mechanism\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "div-external-api" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "ext-api-desc" }, [
                              _c("div", { staticClass: "ext-api-url" }, [
                                _vm.dataSetup.sourceExternal
                                  ? _c("span", { staticClass: "method" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.dataSetup.sourceExternal.method
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.dataSetup.sourceExternal
                                        ? _vm.dataSetup.sourceExternal.url
                                        : "API Not Configure"
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "edit-btn",
                                  on: {
                                    click: function($event) {
                                      _vm.openModalExternalUrl()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Edit\n              "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    (_vm.dataSetup.type.id === "relation_record" ||
                      _vm.dataSetup.type.id === "multiple_relation_record" ||
                      (_vm.dataSetup.type.id === "dynamic_field" &&
                        _vm.dataSetup.viewOptions === "render"))
                      ? _c(
                          "div",
                          {
                            staticClass: "configuration-section",
                            class: {
                              "error-input":
                                _vm.dataSetup.type.id === "dynamic_field" &&
                                _vm.dataSetup.viewOptions === "render" &&
                                _vm.$v.dataSetup.filter.$error
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(2),
                                _vm._v(" "),
                                _c("div", { staticClass: "filter-option" }, [
                                  _c(
                                    "div",
                                    { staticClass: "filter-selected" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.dataSetup.filterOperator)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-down",
                                    on: {
                                      click: function($event) {
                                        _vm.showFilterOptions = true
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.showFilterOptions
                                    ? _c(
                                        "div",
                                        { staticClass: "filter-options" },
                                        [
                                          _c("p", [_vm._v("Operator")]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-around"
                                            },
                                            _vm._l(
                                              _vm.filterOperatorOptions,
                                              function(operator) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: operator.id,
                                                    staticClass:
                                                      "operator-option",
                                                    class: {
                                                      "operator-selected":
                                                        operator.id ===
                                                        _vm.dataSetup
                                                          .filterOperator
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.closeFilterOptions(
                                                          operator.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(operator.name) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.filter, function(data, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "div-filter" },
                                [
                                  _c("div", { staticClass: "header-filter" }, [
                                    _c("div", { staticClass: "index" }, [
                                      _vm._v(_vm._s(index + 1))
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteFilter(index)
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    {
                                      staticClass: "mb-2",
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.filter.$each[index]
                                            .key.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Column ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.dataSetup.filter.$each[index]
                                              .key.$error,
                                          options: _vm.list_field_class,
                                          placeholder: "Select Column",
                                          "value-format": "object",
                                          label: "label"
                                        },
                                        model: {
                                          value: data.key,
                                          callback: function($$v) {
                                            _vm.$set(data, "key", $$v)
                                          },
                                          expression: "data.key"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.filter.$each[index]
                                            .value.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Value ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.dataSetup.filter.$each[index]
                                              .value.$error,
                                          placeholder: "Input Filter Value"
                                        },
                                        model: {
                                          value: data.value,
                                          callback: function($$v) {
                                            _vm.$set(data, "value", $$v)
                                          },
                                          expression: "data.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addFilter }
                              },
                              [
                                _vm._v(
                                  "\n            + Add Parameter\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.type.id === "relation_record" ||
                            _vm.dataSetup.type.id === "multiple_relation_record"
                              ? _c("div", { staticClass: "separator" })
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.dataSetup.type.id === "relation_record" ||
                              _vm.dataSetup.type.id ===
                                "multiple_relation_record") &&
                            !_vm.isTableEditable
                              ? _c(
                                  "div",
                                  { staticClass: "configuration-section" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "configuration-toggle-in-title"
                                      },
                                      [
                                        _vm._m(3),
                                        _vm._v(" "),
                                        _c("j-switch", {
                                          model: {
                                            value: _vm.dataSetup.isWithParam,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.dataSetup,
                                                "isWithParam",
                                                $$v
                                              )
                                            },
                                            expression: "dataSetup.isWithParam"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.dataSetup.isWithParam
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "b-form",
                                              {
                                                staticClass: "mb-2",
                                                class: {
                                                  "error-input":
                                                    _vm.$v.dataSetup
                                                      .filterColumn.$error
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(" Column ")
                                                ]),
                                                _vm._v(" "),
                                                _c("j-single-select", {
                                                  attrs: {
                                                    "error-required":
                                                      _vm.$v.dataSetup
                                                        .filterColumn.$error,
                                                    options:
                                                      _vm.list_field_class,
                                                    label: "label",
                                                    placeholder: "Select Column"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.$v.dataSetup
                                                        .filterColumn.$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.dataSetup
                                                          .filterColumn,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "$v.dataSetup.filterColumn.$model"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form",
                                              {
                                                staticClass: "mb-2",
                                                class: {
                                                  "error-input":
                                                    _vm.$v.dataSetup.fieldKey
                                                      .$error
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(" Value ")
                                                ]),
                                                _vm._v(" "),
                                                _c("j-single-select", {
                                                  attrs: {
                                                    "error-required":
                                                      _vm.$v.dataSetup.fieldKey
                                                        .$error,
                                                    options: _vm.list_field_key,
                                                    label: "id",
                                                    placeholder:
                                                      "Input Filter Value"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.$v.dataSetup.fieldKey
                                                        .$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.dataSetup
                                                          .fieldKey,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "$v.dataSetup.fieldKey.$model"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    (_vm.dataSetup.type.id === "relation_record" ||
                      _vm.dataSetup.type.id === "multiple_relation_record")
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Sorting")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            The displayed data can be sorted according to the specified parameters\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                staticClass: "mb-2",
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sorting.key.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Column ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    "error-required": false,
                                    options: _vm.list_field_class,
                                    placeholder: "Select column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.sorting.key,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup.sorting,
                                        "key",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.sorting.key"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                staticClass: "mb-3",
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sorting.order.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Order Type ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    "error-required": false,
                                    options: _vm.orderOptions,
                                    placeholder: "Select order type",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.sorting.order,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup.sorting,
                                        "order",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.sorting.order"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record" ||
                    _vm.dataSetup.type.id === "multiple_relation_record"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Data Selection")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Data selection is defined as the process of determining the appropriate data type and source on this field\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.setValue.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Value Selected ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field,
                                    label: "name",
                                    placeholder: "Select column"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.setValue
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData.setValue,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.setValue.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.showData.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Show Data Option ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field,
                                    label: "name",
                                    placeholder: "Select column"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.showData
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData.showData,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.showData.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.searchData
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Search Data Option ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field,
                                    label: "name",
                                    placeholder: "Select column"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.searchData
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData.searchData,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.searchData.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.type !== "data_preview"
                              ? _c(
                                  "b-form",
                                  {
                                    staticClass: "d-flex flex-column",
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.isAutoShow.$error
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(" Auto Show All Data ")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.dataSetup.isAutoShow,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isAutoShow",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.isAutoShow"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record_external_api" ||
                    _vm.dataSetup.type.id ===
                      "multiple_relation_record_external_api"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Data Selection")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Data selection is defined as the process of determining the appropriate data type and source on this field\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceExternalVariable
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Show Data Option ")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: { placeholder: "Enter variable" },
                                  model: {
                                    value: _vm.dataSetup.sourceExternalVariable,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "sourceExternalVariable",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.sourceExternalVariable"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceExternalSetValue
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Value Selected ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field_external,
                                    placeholder: "Select column"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceExternalSetValue
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceExternalSetValue,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceExternalSetValue.$model"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.type !== "data_preview"
                              ? _c(
                                  "b-form",
                                  {
                                    staticClass: "d-flex flex-column",
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.isAutoShow.$error
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(" Auto Show All Data ")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.dataSetup.isAutoShow,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isAutoShow",
                                            $$v
                                          )
                                        },
                                        expression: "dataSetup.isAutoShow"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "dynamic_field" &&
                    _vm.dataSetup.viewOptions === "render"
                      ? _c(
                          "div",
                          {
                            staticClass: "configuration-section",
                            class: {
                              "error-input":
                                _vm.dataSetup.type.id === "dynamic_field" &&
                                _vm.dataSetup.viewOptions === "render" &&
                                _vm.$v.dataSetup.sourceData.dataSelection.$error
                            }
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Data Selection")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Data selection is defined as the process of determining the appropriate data type and source on this field\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.sourceData.dataSelection
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Column ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.list_field_data_selection,
                                    label: "name",
                                    placeholder: "Select column"
                                  },
                                  model: {
                                    value:
                                      _vm.$v.dataSetup.sourceData.dataSelection
                                        .$model,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.$v.dataSetup.sourceData
                                          .dataSelection,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.dataSetup.sourceData.dataSelection.$model"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record" &&
                    !_vm.isTableEditable &&
                    !_vm.isBulk &&
                    !_vm.isSearch &&
                    _vm.type !== "data_preview"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isAutoFill,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "isAutoFill", $$v)
                                    },
                                    expression: "dataSetup.isAutoFill"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.isAutoFill
                              ? _c(
                                  "draggable",
                                  {
                                    staticClass: "d-flex flex-wrap",
                                    attrs: {
                                      options: {
                                        animation: 300,
                                        handle: ".icon-drag"
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetup.fieldGroup,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "fieldGroup",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.fieldGroup"
                                    }
                                  },
                                  _vm._l(_vm.dataSetup.fieldGroup, function(
                                    data,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "field-list",
                                        class: {
                                          selected:
                                            index === _vm.selectedIndexField
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.editField(index, "data_preview")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "column-name" },
                                          [_vm._v(_vm._s(data.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("field-preview", {
                                          attrs: { column: data }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "edit-or-delete" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "button" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "edit",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.editField(
                                                          index,
                                                          "data_preview"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil-square-o"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.deleteField(index)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataSetup.isAutoFill
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "btn-add-config",
                                    on: {
                                      click: function($event) {
                                        _vm.openModalFieldLibrary(
                                          "data_preview"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            + Add Field\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.dataSetup.type.id === "relation_record" ||
                      _vm.dataSetup.type.id ===
                        "relation_record_external_api") &&
                    !_vm.isTableEditable &&
                    !_vm.isBulk &&
                    !_vm.isSearch &&
                    _vm.type !== "data_preview"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(5),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isDirectOpenDetail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "isDirectOpenDetail",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.isDirectOpenDetail"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.isDirectOpenDetail
                              ? _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.formUiDirectOpenDetail
                                          .$error
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(" Experience Manager")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        "load-options": _vm.loadOptionsFormUI,
                                        "is-async": true,
                                        "cache-option": false,
                                        placeholder: "Experience Manager",
                                        "value-format": "object",
                                        label: "name"
                                      },
                                      model: {
                                        value:
                                          _vm.dataSetup.formUiDirectOpenDetail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "formUiDirectOpenDetail",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.formUiDirectOpenDetail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "relation_record_external_api" &&
                    !_vm.isTableEditable &&
                    !_vm.isBulk &&
                    !_vm.isSearch &&
                    _vm.type !== "data_preview"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(6),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isAutoFill,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataSetup, "isAutoFill", $$v)
                                    },
                                    expression: "dataSetup.isAutoFill"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.isAutoFill
                              ? _c(
                                  "draggable",
                                  {
                                    staticClass: "d-flex flex-wrap",
                                    attrs: {
                                      options: {
                                        animation: 300,
                                        handle: ".icon-drag"
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetup.fieldGroup,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataSetup,
                                          "fieldGroup",
                                          $$v
                                        )
                                      },
                                      expression: "dataSetup.fieldGroup"
                                    }
                                  },
                                  _vm._l(_vm.dataSetup.fieldGroup, function(
                                    data,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "field-list",
                                        class: {
                                          selected:
                                            index === _vm.selectedIndexField
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.editField(index, "data_preview")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "column-name" },
                                          [_vm._v(_vm._s(data.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("field-preview", {
                                          attrs: { column: data }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "edit-or-delete" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "button" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "edit",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.editField(
                                                          index,
                                                          "data_preview"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-pencil-square-o"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "delete",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        _vm.deleteField(index)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-trash"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataSetup.isAutoFill
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "btn-add-config",
                                    on: {
                                      click: function($event) {
                                        _vm.openModalFieldLibrary(
                                          "data_preview"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            + Add Field\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.dataSetup.type.id === "date" ||
                      _vm.dataSetup.type.id === "date_time") &&
                    !_vm.isBulk &&
                    !_vm.isSearch &&
                    _vm.type !== "data_preview"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.isDisableBackDate.$error
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "configuration-toggle-in-title"
                                  },
                                  [
                                    _c("div", { staticClass: "wrap-title" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "configuration-section-title"
                                        },
                                        [_vm._v("Disable Back Date")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "configuration-section-desc m-0"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Disabling the date picker before today\n                "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("j-switch", {
                                      model: {
                                        value: _vm.dataSetup.isDisableBackDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup,
                                            "isDisableBackDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.isDisableBackDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowInitialValue
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Set Initial Value")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "div-summary-list-type mt-2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "type",
                                    class: {
                                      "type--active":
                                        _vm.dataSetup.initialValue.type ===
                                        "static_value"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setInitialValueType("static_value")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Static\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "type",
                                    class: {
                                      "type--active":
                                        _vm.dataSetup.initialValue.type ===
                                        "function"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.setInitialValueType("function")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Function\n            "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dataSetup.initialValue.type === "static_value"
                              ? _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.initialValue.value
                                          .$error
                                    }
                                  },
                                  [
                                    _c("label", [_vm._v("Value")]),
                                    _vm._v(" "),
                                    _c("j-input", {
                                      attrs: {
                                        "error-required": false,
                                        placeholder: "Enter value"
                                      },
                                      model: {
                                        value: _vm.dataSetup.initialValue.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup.initialValue,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.initialValue.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.dataSetup.initialValue.type === "function"
                              ? [
                                  _c(
                                    "b-form",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.dataSetup.initialValue
                                            .function_name.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v("Function")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required": false,
                                          options: _vm.listFunction,
                                          placeholder: "Select function",
                                          label: "name"
                                        },
                                        model: {
                                          value:
                                            _vm.dataSetup.initialValue
                                              .function_name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup.initialValue,
                                              "function_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dataSetup.initialValue.function_name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    [
                                      _c("label", [_vm._v("Params")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.dataSetup.initialValue.params,
                                        function(data, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "form-list"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: data.variable,
                                                    expression: "data.variable"
                                                  }
                                                ],
                                                staticClass: "name",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Variable"
                                                },
                                                domProps: {
                                                  value: data.variable
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      data,
                                                      "variable",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: data.value,
                                                    expression: "data.value"
                                                  }
                                                ],
                                                staticClass: "value",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Value"
                                                },
                                                domProps: { value: data.value },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      data,
                                                      "value",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fa fa-trash",
                                                on: {
                                                  click: function($event) {
                                                    _vm.deleteParamInitialValue(
                                                      index
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-add-config",
                                          on: {
                                            click: _vm.addParamInitialValue
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                + Add Params\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.dataSetup.type.id === "number" ||
                      _vm.dataSetup.type.id === "number_decimal" ||
                      _vm.dataSetup.type.id === "currency" ||
                      _vm.dataSetup.type.id === "single_selection" ||
                      _vm.dataSetup.type.id === "text" ||
                      _vm.dataSetup.type.id === "date" ||
                      _vm.dataSetup.type.id === "time" ||
                      _vm.dataSetup.type.id === "date_time" ||
                      _vm.dataSetup.type.id === "radio" ||
                      _vm.dataSetup.type.id === "checkbox" ||
                      _vm.dataSetup.type.id === "toggle" ||
                      _vm.dataSetup.type.id === "password" ||
                      _vm.dataSetup.type.id === "single_attachment" ||
                      _vm.dataSetup.type.id === "relation_record" ||
                      _vm.dataSetup.type.id ===
                        "relation_record_external_api" ||
                      _vm.dataSetup.type.id === "descriptive" ||
                      _vm.dataSetup.type.id === "currency_selection" ||
                      _vm.dataSetup.type.id === "slider") &&
                    !_vm.isTableEditable &&
                    !_vm.isBulk &&
                    !_vm.isSearch &&
                    !_vm.isDataset &&
                    _vm.type !== "data_preview"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(7),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isValueChange,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "isValueChange",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.isValueChange"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.useEditorCode
                              ? _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup.onValueChange.$error
                                    }
                                  },
                                  [
                                    _c("label", { staticClass: "mb-0" }, [
                                      _vm._v(" Script ")
                                    ]),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "pull-right cursor-pointer",
                                      attrs: {
                                        src: require("@/assets/icon/fullscreen.svg"),
                                        alt: "fullscreen"
                                      },
                                      on: { click: _vm.fullscreenScript }
                                    }),
                                    _vm._v(" "),
                                    _vm.openEditor
                                      ? _c("j-monaco-editor", {
                                          ref: "scriptEditor",
                                          attrs: {
                                            value: _vm.dataSetup.onValueChange
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    (_vm.dataSetup.type.id === "group" ||
                      _vm.dataSetup.type.id === "table_group") &&
                    _vm.variableOptionsGroup.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "configuration-section",
                            class: {
                              "error-input": _vm.$v.dataSetup.fieldGroup.$error
                            }
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Fields")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            The field used can be adjusted as needed\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              {
                                staticClass: "d-flex flex-wrap",
                                attrs: {
                                  options: {
                                    animation: 300,
                                    handle: ".icon-drag"
                                  }
                                },
                                model: {
                                  value: _vm.dataSetup.fieldGroup,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataSetup, "fieldGroup", $$v)
                                  },
                                  expression: "dataSetup.fieldGroup"
                                }
                              },
                              _vm._l(_vm.dataSetup.fieldGroup, function(
                                data,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "field-list",
                                    class: {
                                      selected: index === _vm.selectedIndexField
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.editField(index, "group")
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "column-name" }, [
                                      _vm._v(_vm._s(data.name))
                                    ]),
                                    _vm._v(" "),
                                    _c("field-preview", {
                                      attrs: { column: data }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "edit-or-delete" },
                                      [
                                        _c("div", { staticClass: "button" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "edit",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.editField(index, "group")
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-pencil-square-o"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "delete",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  _vm.deleteField(index)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash"
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: {
                                  click: function($event) {
                                    _vm.openModalFieldLibrary("group")
                                  }
                                }
                              },
                              [_vm._v("\n            + Add Field\n          ")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    (_vm.dataSetup.type.id === "group" ||
                      _vm.dataSetup.type.id === "table_group") &&
                    _vm.variableOptionsGroup.length > 0
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "h4",
                            { staticClass: "configuration-section-title mb-2" },
                            [_vm._v("Disable Buttons")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "div-input-location" },
                            [
                              _c("label", [_vm._v("Add More")]),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isDisableAddMore,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isDisableAddMore",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isDisableAddMore"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "div-input-location" },
                            [
                              _c("label", [_vm._v("Delete Row")]),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isDisableDeleteRow,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isDisableDeleteRow",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isDisableDeleteRow"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "single_tags_selection" ||
                    _vm.dataSetup.type.id === "multiple_tags_selection"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "configuration-section-title mb-2"
                              },
                              [_vm._v("Options")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dataSetup.tags, function(item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "div-filter" },
                                [
                                  _c("div", { staticClass: "header-filter" }, [
                                    _c("div", { staticClass: "index" }, [
                                      _vm._v(_vm._s(index + 1))
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteTags(index)
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-form",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("label", [_vm._v(" Name ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          placeholder: "Enter Name Value"
                                        },
                                        model: {
                                          value: item.name,
                                          callback: function($$v) {
                                            _vm.$set(item, "name", $$v)
                                          },
                                          expression: "item.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c("j-color-picker", {
                                            attrs: {
                                              color: item.background,
                                              label: "Background",
                                              picker: "chrome"
                                            },
                                            model: {
                                              value: item.background,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "background",
                                                  $$v
                                                )
                                              },
                                              expression: "item.background"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c("j-color-picker", {
                                            attrs: {
                                              color: item.font_color,
                                              label: "Font Color",
                                              picker: "chrome"
                                            },
                                            model: {
                                              value: item.font_color,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "font_color",
                                                  $$v
                                                )
                                              },
                                              expression: "item.font_color"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "btn-add-config",
                                on: { click: _vm.addTags }
                              },
                              [
                                _vm._v(
                                  "\n            + Add Options\n          "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.type !== "group" || _vm.type !== "data_preview") &&
                    _vm.dataSetup.type.id === "custom_html"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c("quill-editor", {
                              ref: "myQuillEditor",
                              attrs: { options: _vm.editorOption },
                              model: {
                                value: _vm.dataSetup.html,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "html", $$v)
                                },
                                expression: "dataSetup.html"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    _vm.dataSetup.type.id === "code_editor"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "h4",
                            { staticClass: "configuration-section-title" },
                            [_vm._v("Language")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "configuration-section-desc" },
                            [
                              _vm._v(
                                "\n            The programming language used as the default language in the code editor\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            _vm._l(_vm.languageOptions, function(language) {
                              return _c(
                                "div",
                                {
                                  key: language.id,
                                  staticClass: "div-list-language",
                                  class: {
                                    active:
                                      language.id === _vm.dataSetup.language
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.dataSetup.language = language.id
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(language.name) +
                                      "\n            "
                                  )
                                ]
                              )
                            })
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type !== "data_preview" &&
                    (_vm.dataSetup.type.id === "multiple_relation_record" ||
                      _vm.dataSetup.type.id ===
                        "multiple_relation_record_external_api")
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(8),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isAllowSelectAllData,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isAllowSelectAllData",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isAllowSelectAllData"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "currency_selection"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "configuration-toggle-in-title" },
                              [
                                _vm._m(9),
                                _vm._v(" "),
                                _c("j-switch", {
                                  model: {
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "isAdditionalDataKey",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                ],
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.additionalOriginAmount
                                      .$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(" Column (Origin Amount) ")
                                ]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptions.filter(
                                      function(f) {
                                        return f.type === "number"
                                      }
                                    ),
                                    "error-required": false,
                                    placeholder: "Select Column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.additionalOriginAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "additionalOriginAmount",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.additionalOriginAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                ],
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.additionalOriginCurrency
                                      .$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(" Column (Origin Currency) ")
                                ]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptions.filter(
                                      function(f) {
                                        return f.type === "text"
                                      }
                                    ),
                                    "error-required": false,
                                    placeholder: "Select Column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup.additionalOriginCurrency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "additionalOriginCurrency",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.additionalOriginCurrency"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                ],
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.additionalConvertionAmount
                                      .$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(" Column (Convertion Amount) ")
                                ]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptions.filter(
                                      function(f) {
                                        return f.type === "number"
                                      }
                                    ),
                                    "error-required": false,
                                    placeholder: "Select Column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup.additionalConvertionAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "additionalConvertionAmount",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.additionalConvertionAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                ],
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.additionalTargetCurrency
                                      .$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(" Column (Target Currency) ")
                                ]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptions.filter(
                                      function(f) {
                                        return f.type === "text"
                                      }
                                    ),
                                    "error-required": false,
                                    placeholder: "Select Column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup.additionalTargetCurrency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "additionalTargetCurrency",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.additionalTargetCurrency"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dataSetup.isAdditionalDataKey,
                                    expression: "dataSetup.isAdditionalDataKey"
                                  }
                                ],
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.additionalRate.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Column (Rate) ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.variableOptions.filter(
                                      function(f) {
                                        return f.type === "number"
                                      }
                                    ),
                                    "error-required": false,
                                    placeholder: "Select Column",
                                    "value-format": "object",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.dataSetup.additionalRate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "additionalRate",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetup.additionalRate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "currency_selection"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(10),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isEditableRate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isEditableRate",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isEditableRate"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "currency" ||
                    _vm.dataSetup.type.id === "currency_selection"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(11),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isAllowMinusValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isAllowMinusValue",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isAllowMinusValue"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isDetailView &&
                    _vm.isApproverCanUpdate &&
                    _vm.type !== "data_preview" &&
                    _vm.dataSetup.type.id !== "separator" &&
                    _vm.dataSetup.type.id !== "custom_html"
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(12),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isAllowApproverUpdate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isAllowApproverUpdate",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isAllowApproverUpdate"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "text_label"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Style")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Custom design and appearance for text labels\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.style_text_label, function(item, index) {
                              return _c("div", { key: index }, [
                                _c("label", [_vm._v(_vm._s(item.label))]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "div-summary-list-type" },
                                  _vm._l(item.options, function(opt) {
                                    return _c(
                                      "div",
                                      {
                                        key: opt,
                                        staticClass: "type",
                                        class: {
                                          "type--active": _vm.checkActiveStyleTextLabel(
                                            item.label,
                                            opt
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.setStyleTextLabel(
                                              item.label,
                                              opt
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/new-form-ui/text-label/" +
                                              opt +
                                              (_vm.checkActiveStyleTextLabel(
                                                item.label,
                                                opt
                                              )
                                                ? "-active"
                                                : "") +
                                              ".svg")
                                          }
                                        })
                                      ]
                                    )
                                  })
                                )
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "text_label" &&
                    _vm.dataSetup.formatTextLabel === "text"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Hyperlink")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            When the label is clicked it will be directed to the following link\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                placeholder:
                                  "Enter url static or from hit function"
                              },
                              model: {
                                value: _vm.dataSetup.linkTextLabel,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "linkTextLabel", $$v)
                                },
                                expression: "dataSetup.linkTextLabel"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type.id === "progress_bar"
                      ? _c(
                          "div",
                          { staticClass: "configuration-section" },
                          [
                            _c(
                              "h4",
                              { staticClass: "configuration-section-title" },
                              [_vm._v("Color")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "configuration-section-desc" },
                              [
                                _vm._v(
                                  "\n            Custom appearance for progress bar\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("j-color-picker", {
                              attrs: {
                                color: _vm.dataSetup.progressBarColor,
                                label: "Color",
                                picker: "chrome"
                              },
                              model: {
                                value: _vm.dataSetup.progressBarColor,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "progressBarColor",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.progressBarColor"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.useConfigPrivateStorage
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(13),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.isPrivateFile,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "isPrivateFile",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.isPrivateFile"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dataSetup.isPrivateFile
                            ? _c(
                                "div",
                                { staticClass: "company-drive-path" },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c("label", [
                                        _vm._v(" Company Drive Path ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: { placeholder: "Input Path" },
                                        model: {
                                          value: _vm.dataSetup.companyDrivePath,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dataSetup,
                                              "companyDrivePath",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "dataSetup.companyDrivePath"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-search icon-search",
                                    on: {
                                      click: function($event) {
                                        _vm.$emit("open-modal-company-drive")
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.useConfigEnableCopyValue
                      ? _c("div", { staticClass: "configuration-section" }, [
                          _c(
                            "div",
                            { staticClass: "configuration-toggle-in-title" },
                            [
                              _vm._m(14),
                              _vm._v(" "),
                              _c("j-switch", {
                                model: {
                                  value: _vm.dataSetup.enableCopyValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataSetup,
                                      "enableCopyValue",
                                      $$v
                                    )
                                  },
                                  expression: "dataSetup.enableCopyValue"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "properties-field-button",
                class: { "justify-content-end": !_vm.dataSetup.name }
              },
              [
                _vm.dataSetup.name
                  ? _c(
                      "button",
                      {
                        staticClass: "button-border",
                        attrs: { disabled: _vm.showModalFieldLibrary },
                        on: { click: _vm.deleteSourceField }
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash" }),
                        _vm._v(" Delete\n      ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button-border mr-2",
                      attrs: { disabled: _vm.showModalFieldLibrary },
                      on: {
                        click: function($event) {
                          _vm.submitForm(true)
                        }
                      }
                    },
                    [_vm._v("\n          Close\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button-blue",
                      attrs: { disabled: _vm.showModalFieldLibrary },
                      on: {
                        click: function($event) {
                          _vm.submitForm(false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.fieldDetail && _vm.fieldDetail.field_ui_key
                              ? "Update"
                              : "Apply"
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idPropertiesGroup,
            attrs: {
              id: _vm.id.concat([_vm.idPropertiesGroup]),
              "stack-level": 2,
              "field-detail": _vm.selectedField,
              "variable-options":
                (_vm.dataSetup.type.id === "relation_record" ||
                  _vm.dataSetup.type.id === "relation_record_external_api") &&
                !_vm.isBulk &&
                (!_vm.variableOptionsGroup ||
                  _vm.variableOptionsGroup.length === 0)
                  ? _vm.list_field
                  : _vm.variableOptionsGroup,
              "field-ui-key": _vm.dataSetup.fieldGroup,
              type: _vm.propertiesType,
              "parent-type": _vm.fieldDetail.type,
              "is-detail-view": _vm.isDetailView,
              "is-group": true,
              "is-new-field": _vm.isNewFieldGroup,
              "native-buttons": _vm.nativeButtons
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.togglePropertiesField(false)
              },
              "submit-mode": _vm.submitField,
              "open-modal-full-script": _vm.openModalFullScript,
              "open-modal-company-drive": _vm.openModalCompanyDrive
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSubField
        ? _c("properties-field", {
            ref: _vm.idPropertiesSubGroup,
            attrs: {
              id: _vm.id.concat([_vm.idPropertiesSubGroup]),
              "stack-level": 3,
              "field-detail": _vm.selectedSubField,
              "variable-options":
                (_vm.dataSetup.type.id === "relation_record" ||
                  _vm.dataSetup.type.id === "relation_record_external_api") &&
                !_vm.isBulk &&
                (!_vm.variableOptionsGroup ||
                  _vm.variableOptionsGroup.length === 0)
                  ? _vm.list_field
                  : _vm.variableOptionsGroup,
              "field-ui-key": _vm.dataSetup.fieldGroup,
              type: _vm.propertiesSubType,
              "parent-type": _vm.fieldDetail.type,
              "is-detail-view": _vm.isDetailView,
              "is-group": true,
              "is-new-field": _vm.isNewFieldSubGroup,
              "native-buttons": _vm.nativeButtons
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.togglePropertiesSubField(false)
              },
              "submit-mode": _vm.submitField
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n        Properties\n        "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Field")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-ext-api" }, [
      _c("img", { attrs: { src: require("@/assets/new-form-ui/ext-api.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Filter data according to the parameters\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Retrieve data from Value Field")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Data Preview")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Displays the selected data with a customizable form display\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Direct Open Detail")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Allow users to open detailed info of selected data in a new tab\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Data Preview")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Displays the selected data with a customizable form display\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("On Change Value")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                The change event occurs when the value of an element has been changed\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Allow Select All Data")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                One action to select or unselect all data options\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Parse value to another column")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Automatically separates values into other columns\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Editable Rate")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                The rate currency editable by user\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Allow Minus Value")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Show currency in brackets as minus value sign\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Allow approver to edit")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Approver can edit and update value of this field before continue to approve\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Private file")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Store the uploaded file to private storage\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title m-0" }, [
        _vm._v("Enable Copy Value")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Quickly copy specific data or field values with a single click\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2582c534", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2582c534","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/PropertiesField.vue
// module id = null
// module chunks = 